import type { HeatNoString, IndividualResult } from '@/components/results/store-comp-results'
import { cleanUpScoreValueForDisplay } from '@/components/results/results-service'
import type {
  SocketResultMessagePayloadResultsManual,
  SocketResultPayloadResultManual
} from '@/components/results/socket/socket-results-manual/socket-results-manual-models'

export function mapSocketResultPayloadResultManualToIndividualResult(
  socketResultPayloadResultManual: SocketResultPayloadResultManual
): IndividualResult {
  return {
    laneNo: socketResultPayloadResultManual.laneNo,
    position: socketResultPayloadResultManual.position,
    wind: socketResultPayloadResultManual.wind,
    athlete: socketResultPayloadResultManual.athlete,
    athleteId: socketResultPayloadResultManual.athleteId,
    affilation: socketResultPayloadResultManual.clubName,
    bibNo: socketResultPayloadResultManual.bibNo.toString(),
    score: cleanUpScoreValueForDisplay(socketResultPayloadResultManual.scoreValue),
    qualify: socketResultPayloadResultManual.qualify,
    ageGroup: socketResultPayloadResultManual.ageGroup
  }
}

function mapSocketResultPayloadResultsManualToIndividualResults(
  socketResultPayloadResultsManual: SocketResultPayloadResultManual[]
): IndividualResult[] {
  return socketResultPayloadResultsManual.map((result) => {
    return mapSocketResultPayloadResultManualToIndividualResult(result)
  })
}

export function mapResultsManual(
  socketResultMessagePayloadResultsManual: SocketResultMessagePayloadResultsManual
): Record<HeatNoString, IndividualResult[]> {
  //  update the results for the event
  const heats = socketResultMessagePayloadResultsManual.heats

  //  Loop through the heats and map the results using reduce
  const result: Record<HeatNoString, IndividualResult[]> = heats.reduce<
    Record<HeatNoString, IndividualResult[]>
  >((acc, heat) => {
    const results = mapSocketResultPayloadResultsManualToIndividualResults(heat.results)
    acc[heat.heatNo.toString()] = results
    return acc
  }, {})

  return result
}
